import React from 'react';
import {useNetwork} from '../contexts/NetworkContext';
export default function SyncStatus(){
 const {status,pendingWrites}=useNetwork();
 const copy=status==='offline'?'Offline mode':status==='syncing'?`Syncing${pendingWrites?` · ${pendingWrites}`:''}`:'Online';
 return <span className={`sync-status sync-${status}`} title={status==='offline'?'Cached data remains available. Safe Database edits are queued and sync when connectivity returns.':'Connectivity and local sync status'}><i/>{copy}</span>;
}
